import React from "react";
import { withState } from "recompose";
import styled from "styled-components";

import Catalog from "../catalog/index";
import BlocksTree from "../canvas/tree";
import Layers from "../canvas/layers";
import SheetTree from "../spreadsheet/tree";

import { headerHeight } from "./header";
import { toggleCatalog } from "./editor";
import { HCenter, VCenter, Divider, HR, Showable } from "../reusable/layout";
import * as Colors from "../reusable/colors";
import * as Icons from "../reusable/icons";
import { ElementUI, ElementToolTip } from "../reusable/components";
import logo from "../reusable/images/logo.svg";

export const leftMenuWidth = 160;

const LeftMenu = styled.div`
  flex: 0 0 ${leftMenuWidth}px;
  max-width: ${leftMenuWidth}px;
  min-width: ${leftMenuWidth}px;
  z-index: 30;
  text-align: center;
  background-color: ${Colors.secondary};
  border-right: 1px solid ${Colors.separatorDark};
`;

const TitleHeader = styled.div`
  height: ${headerHeight}px;
  ${HCenter};
  ${VCenter};
  flex-direction: column;
`;

const Title = styled.div`
  border-bottom: 2px solid ${Colors.separatorDark};
  font-size: 2.3em;
  font-weight: bold;
  letter-spacing: 3px;
`;

const Expandable = styled.li`
  width: 100%;
  ${HCenter};
  position: relative;
`;

const SideCar = styled.div`
  background-color: ${Colors.primary};
  padding: ${p => (p.padding || "20") + "px"};
  width: ${p => p.width + "px"};
  bottom: -30px;
  right: ${p => -p.width + "px"};
  position: absolute;
  opacity: ${p => (p.show ? 1 : 0)};
  transition: opacity 0.4s ease-out;
  z-index: 30;
  text-align: left;
`;

const MenuItem = styled.div`
  ${VCenter};
  ${HCenter};
  flex-direction: column;
  & > i:hover {
    color: white;
  }
  & > i {
    cursor: pointer;
  }
  font-size: 3em;
`;

const Logo = styled.img`
  width: 50%;
  border: 1px solid ${Colors.separatorLight};
  border-radius: 100%;
`;

const HCenterMe = styled.div`
  ${HCenter};
`;

export default () => {
  return (
    <LeftMenu>
      <TitleHeader>
        <Logo src={logo} />
      </TitleHeader>
      <Divider h="50px" />
      <MenuItem onClick={toggleCatalog}>
        <Icons.Add />
      </MenuItem>
      <Divider h="58px" />
      <Layers />
    </LeftMenu>
  );
};

const enhance = withState("leftExpand", "setLeftExpand", undefined);
export const tt = enhance(({ leftExpand, setLeftExpand }) => (
  <LeftMenu>
    <TitleHeader>
      <Title>.se</Title>
    </TitleHeader>
    <Divider h="50px" />
    <Catalog />
    <Divider h="15px" />
    <HCenterMe>
      <HR color={Colors.primary} width="50%" />
    </HCenterMe>
    <Divider h="22px" />
    <Expandable>
      {leftExpand === "tree" && (
        <Showable>
          <SideCar key="tree" width={200}>
            <BlocksTree />
          </SideCar>
        </Showable>
      )}
      <div className="element-ui">
        <ElementToolTip>Layers</ElementToolTip>
        <ElementUI onClick={() => setLeftExpand(!leftExpand && "tree")}>
          <Icons.Undo />
        </ElementUI>
      </div>
    </Expandable>
    <Divider h="20px" />
    <Expandable>
      {leftExpand === "spread" && (
        <Showable>
          <SideCar key="spread" width={100} padding="0px">
            <SheetTree />
          </SideCar>
        </Showable>
      )}
      <div className="element-ui">
        <ElementToolTip>Content</ElementToolTip>
        <ElementUI onClick={() => setLeftExpand(!leftExpand && "spread")}>
          <Icons.Plug />
        </ElementUI>
      </div>
    </Expandable>
  </LeftMenu>
));



// WEBPACK FOOTER //
// ./src/layout/explorer.js